import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/shared";

export const Mission = () => {
  const { t } = useLang();
  const m = t.mission;

  return (
    <section id="mission" data-testid="mission" className="border-t border-zinc-200 bg-zinc-50">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:px-12 md:py-32">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-16">
          <div className="md:col-span-5">
            <Reveal>
              <Overline>{m.overline}</Overline>
              <h2 className="mt-6 font-heading text-3xl font-light tracking-tight text-zinc-900 sm:text-5xl">
                {m.title}
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-7">
            <Reveal i={1}>
              <p className="text-base leading-relaxed text-zinc-600 sm:text-lg">{m.body}</p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 border-t border-zinc-300 md:grid-cols-3">
          {m.pillars.map((p, i) => (
            <Reveal key={p.title} i={i}>
              <div
                data-testid="mission-pillar"
                className="group h-full border-zinc-300 px-2 py-10 transition-colors md:border-r md:px-8 md:last:border-r-0"
              >
                <span className="font-mono text-sm text-zinc-400">0{i + 1}</span>
                <h3 className="mt-4 font-heading text-2xl font-medium text-zinc-900">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-500">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
